var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1435",
    "data-name": "Group 1435",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.9,
    height: 18.9,
    viewBox: "0 0 18.9 18.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M18.9,17.236l-3.923-3.923a8.139,8.139,0,0,0,1.664-4.992A8.27,8.27,0,0,0,8.321,0,8.27,8.27,0,0,0,0,8.321a8.27,8.27,0,0,0,8.321,8.321,8.139,8.139,0,0,0,4.992-1.664L17.236,18.9ZM2.377,8.321A5.886,5.886,0,0,1,8.321,2.377a5.886,5.886,0,0,1,5.943,5.943,5.886,5.886,0,0,1-5.943,5.943A5.886,5.886,0,0,1,2.377,8.321Z",
    fill: "#324562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7a138a82ed1c85345c93a427c20b3068.svg";
export { ForwardRef as ReactComponent };